import { Box, Typography } from "@mui/material";
import HtmlEditor from "../../../../components/editor/HtmlEditor";

interface RecipeInstructionsSectionProps {
    value: string;
    onChange: (value: string) => void;
}

export default function RecipeInstructionsSection({ value, onChange }: RecipeInstructionsSectionProps) {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, height: "100%" }}>
            <Typography variant="h6" fontWeight={600}>
                Instructions
            </Typography>

            <Typography variant="body2" color="text.secondary">
                Write your cooking steps using the editor below. Formatting will be stored as HTML.
            </Typography>

            <HtmlEditor
                value={value}
                onChange={onChange}
            />
        </Box>
    );
}
